import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CSSModules from 'react-css-modules';

import CtaButton from '../common/cta-button';

import styles from './cta-block.module.scss';

const CtaBlock = ({ image, headText, subText, linkText, linkUrl, hasButton, hasImage, isDark, isHuge }) => (
  <div styleName="container">
    <div className="grid-container">
      <div className="grid-x">
        <div className="cell">
          <div
            className="grid-x grid-padding-x"
            styleName={classnames('content', { 'has-image': hasImage, dark: isDark, 'is-huge': isHuge })}
            style={{ backgroundImage: hasImage && `url(${image})` }}
          >
            <div className="cell align-self-middle">
              <div styleName="padder">
                <h1>{headText}</h1>
                <p>{subText}</p>

                {hasButton && (
                  <CtaButton to={linkUrl} isDark={isDark}>
                    {linkText}
                  </CtaButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
CtaBlock.propTypes = {
  hasImage: PropTypes.bool,
  isDark: PropTypes.bool,
  isHuge: PropTypes.bool,
  hasButton: PropTypes.bool,
  image: PropTypes.string,
  headText: PropTypes.string,
  subText: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
};
CtaBlock.defaultProps = {
  hasImage: false,
  hasButton: false,
  isDark: false,
  isHuge: false,
  image: '',
  headText: '',
  subText: '',
  linkText: '',
  linkUrl: '',
};
export const CtaBlockType = PropTypes.shape(CtaBlock.propTypes);

export default CSSModules(CtaBlock, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/cta-block.jsx